module.exports = __webpack_public_path__ + "img/paydirekt.9a1bf658.png";